import { render, staticRenderFns } from "./DetailsEmployee.vue?vue&type=template&id=8f943dac&scoped=true"
import script from "./DetailsEmployee.vue?vue&type=script&lang=js"
export * from "./DetailsEmployee.vue?vue&type=script&lang=js"
import style0 from "./DetailsEmployee.vue?vue&type=style&index=0&id=8f943dac&prod&scoped=true&lang=css"
import style1 from "./DetailsEmployee.vue?vue&type=style&index=1&id=8f943dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f943dac",
  null
  
)

export default component.exports